export default __webpack_public_path__ + "static/media/no-records-found.e4db61d0.png";